import { useState } from "react";
import "./Navbar.css";

const Navbar = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
    });
    setMenuOpen(false);
  };

  return (
    <nav className="navbar-custom">
      <div className="logo">AugDev</div>

      <button
        className={`menu-toggle ${isMenuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen((prev) => !prev)}
        aria-label="Basculer le menu"
      >
        <span />
        <span />
        <span />
      </button>

      <ul className={`nav-links ${isMenuOpen ? "open" : ""}`}>
        <li onClick={() => scrollTo("home")}>Home</li>
        <li onClick={() => scrollTo("about")}>About</li>
        <li onClick={() => scrollTo("portfolio")}>Portfolio</li>
        <li onClick={() => scrollTo("contact")}>Contact</li>
      </ul>
    </nav>
  );
};

export default Navbar;
